import {useEffect, useState} from "react";
import {Box, Typography, Modal, IconButton} from "@mui/material";
import axios from "axios";
import {API_URL} from "../../../config";
import {useParams} from "react-router-dom";
import DownloadIcon from '@mui/icons-material/Download';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';

export default function PhotoGallery({elementPlaying}) {
    const { t } = useTranslation('questions');
    const {eventOwnerId, id: eventId} = useParams();
    const [loading, setLoading] = useState(true);
    const [photos, setPhotos] = useState([]);
    const [openModal, setOpenModal] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        axios.get(`${API_URL}/users/${eventOwnerId}/answer/${eventId}/${elementPlaying.questionReferenceId}`)
            .then(response => {
                setPhotos(response.data);
                setLoading(false);
            })
            .catch(() => {
                console.info(t('photoGallery.error'))
            });
    }, []);

    const getImageSrc = (filename, userId) => {
        const domanda = elementPlaying.questionReferenceId;
        return `https://storage.googleapis.com/2ndstage-public/${userId === "plesh" ? '' : (userId + '/')}${eventId}/${domanda}/${filename}`;
    };

    const openGallery = (index) => {
        setCurrentIndex(index);
        setOpenModal(true);
    };

    const closeGallery = () => {
        setOpenModal(false);
    };

    const goNext = () => {
        setCurrentIndex((prev) => (prev + 1) % photos.length);
    };

    const goPrev = () => {
        setCurrentIndex((prev) => (prev - 1 + photos.length) % photos.length);
    };

    const downloadImage = async (filename, userId) => {
        const imageUrl = getImageSrc(filename, userId);
        try {
            const response = await axios.get(imageUrl, {
                responseType: 'blob',
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.error(t('photoGallery.downloadError'), error);
        }
    };

    const currentPhoto = photos[currentIndex];

    return (
        <Box mt={5}>
            <Box
                sx={{
                    display: 'flex',
                    gap: 1,
                    maxHeight: '60vh',
                    overflowY: 'auto',
                    pr: 1,
                }}
            >
                {[0, 1].map((colIndex) => (
                    <Box
                        key={colIndex}
                        sx={{
                            flex: 1,
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 1,
                        }}
                    >
                        {photos
                            .filter((_, i) => i % 2 === colIndex)
                            .map((photo, index) => (
                                <img
                                    key={photo.id}
                                    src={getImageSrc(photo.filename, photo.user)}
                                    alt=""
                                    style={{ width: '100%', height: 'auto', cursor: 'pointer', display: 'block' }}
                                    onClick={() => openGallery(colIndex + index * 2)}
                                />
                            ))}
                    </Box>
                ))}
            </Box>


            <Modal open={openModal} onClose={closeGallery}>
                <Box
                    position="fixed"
                    top={0}
                    left={0}
                    width="100vw"
                    height="100vh"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    bgcolor="rgba(0,0,0,0.9)"
                    zIndex={9999}
                >
                    <IconButton
                        onClick={closeGallery}
                        sx={{position: "absolute", top: 10, right: 10, color: "#fff"}}
                    >
                        <CloseIcon/>
                    </IconButton>

                    {photos.length > 0 && (
                        <>
                            <IconButton
                                onClick={goPrev}
                                sx={{position: "absolute", left: 10, color: "#fff"}}
                            >
                                ‹
                            </IconButton>

                            <img
                                src={getImageSrc(currentPhoto.filename, currentPhoto.user)}
                                alt=""
                                style={{maxWidth: "80%", maxHeight: "90%"}}
                            />

                            <IconButton
                                onClick={goNext}
                                sx={{position: "absolute", right: 10, color: "#fff"}}
                            >
                                ›
                            </IconButton>

                            <IconButton
                                onClick={() => downloadImage(currentPhoto.filename, currentPhoto.user)}
                                sx={{
                                    position: "absolute",
                                    bottom: 20,
                                    color: "#fff",
                                    bgcolor: "rgba(255,255,255,0.0)",
                                    '&:hover': { bgcolor: "rgba(255,255,255,0.2)" },
                                    mb: 5
                                }}
                            >
                                <DownloadIcon />
                            </IconButton>
                        </>
                    )}
                </Box>
            </Modal>
        </Box>
    );
}
